import { Auth } from 'aws-amplify';
import app from 'general/js/app';
import * as awsExports from './aws-exports';

class AmplifyClient {
    constructor() {
        this.isInited = false;
    }

    init() {
        if (!app.state.ssoConfig) {
            throw new Error('Sso config is missing in app state');
        }

        if (this.isInited) return;

        Auth.configure(awsExports.awsConfig);

        this.isInited = true;
    }
}

export default new AmplifyClient();
